import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MassiveOrderDetailSelectionTable } from 'src/app/models/tables/preliminaries/massive-order-detail-selection-table.model';
import { SalesRemissionFromOrderService } from 'src/app/services/inventory/sales-remission-from-order.service';

@Component({
  selector: 'app-sales-remission-massive-order',
  templateUrl: './sales-remission-massive-order.component.html',
  styleUrls: ['./sales-remission-massive-order.component.scss'],
  standalone: false
})
export class SalesRemissionMassiveOrderComponent implements OnInit {

  readonly config = inject(DynamicDialogConfig);
  private readonly salesRemissionFromOrderService = inject(SalesRemissionFromOrderService);

  filters: ColumnResponseModel[] = [];
  headers: ColumnResponseModel[] = [];
  data: PagedResponseModel<MassiveOrderDetailSelectionTable> =
    new PagedResponseModel<MassiveOrderDetailSelectionTable>();
  page: number = 1;
  columnSort: string | null = null;
  limit: number = 10;
  ascendant: boolean = true;
  inventoryOutputId: number = 0;
  subscription: Subscription;
  loading: boolean = false;

  async ngOnInit() {
    await this.getColumnsForMassiveOrderDetail();
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.inventoryOutputId = inputs.inventoryOutputId;
    });
    this.loading = true;
    await this.getMassiveOrderDetail();
    setTimeout(() => this.loading = false, 300);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async getColumnsForMassiveOrderDetail() {
    try {
      if (this.headers.length == 0) {
        const response = await firstValueFrom(this.salesRemissionFromOrderService.getColumnsForMassiveOrderDetail());
        this.headers = response;
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getMassiveOrderDetail() {
    try {
      const response = await firstValueFrom(this.salesRemissionFromOrderService.getMassiveOrderDetail(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters, this.inventoryOutputId
      ));
      this.data = response;
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getMassiveOrderDetail();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
    await this.getMassiveOrderDetail();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }
}
